/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Try_NowInputs */

const en_common_try_now = /** @type {(inputs: Common_Try_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try now`)
};

const es_common_try_now = /** @type {(inputs: Common_Try_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probar ahora`)
};

/**
* | output |
* | --- |
* | "Try now" |
*
* @param {Common_Try_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_try_now = /** @type {((inputs?: Common_Try_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Try_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_try_now(inputs)
	return en_common_try_now(inputs)
});